import CoreApi from '../../api/CoreApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  benefitId: string;
};

// Note: There's no specific adminGetBenefitDetail endpoint in CoreApi
// We'll work with basic benefit data from adminGetBenefits
export const adminGetBenefitDetail = createQueryFn(
  QueryNameSpace.adminGetBenefitDetail,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, { benefitId }] = queryKey;
    // This is a workaround - we'll get all benefits and find the specific one
    const res = await CoreApi.adminGetBenefitDetail(benefitId);
    if (!res) {
      throw new Error('Benefit not found');
    }
    return res;
  },
);
